import React from 'react';
// 1. Import hydrateRoot for production and createRoot for development
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
//new added
import { hydrate, render } from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 2. Import HelmetProvider to manage SEO Meta tags
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

// 3. Logic to check if content already exists (Pre-rendered by react-snap)
if (container.hasChildNodes()) {
  // If content exists, hydrate it (Production/SEO mode)
  hydrateRoot(
    container,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // If content is empty, render normally (Development mode)
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

reportWebVitals();